'use client';

import React from 'react';
import { Target } from 'lucide-react';

export const YourNextDecision: React.FC = () => {
  return (
    <div className="my-16">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
          <Target className="w-6 h-6 text-blue-600" />
        </div>
        <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900">
          Your Next Decision
        </h2>
      </div>

      <div className="space-y-6 text-lg text-neutral-700 leading-relaxed">
        <p>
          The few who put this all together take 2-3 years of expensive trial and error.
        </p>

        <p>
          Some figure it out. Most don't.
        </p>

        <p>
          This is exactly why rebel iQ exists. You don't have time to become an expert in paid media strategy, conversion optimization, and marketing automation.
        </p>

        <p>
          You're already busy closing loans, working with borrowers, recruiting producing agents, and managing your pipeline.
        </p>

        <p className="text-xl font-semibold text-neutral-900">
          We build the infrastructure while you focus on what you do best.
        </p>

        <p>
          <strong className="text-neutral-900">We handle:</strong> the paid advertising, landing pages that convert, follow-up systems, brand/organic capture, agent partnership frameworks.
        </p>

        <p>
          <strong className="text-neutral-900">You focus on:</strong> closing loans, building relationships, growing your business.
        </p>

        <p className="text-xl font-semibold text-neutral-900">
          Not a course. Not a coaching program. We build the system for you.
        </p>
      </div>
    </div>
  );
};
